import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import UserService from "services/UserService";
import { makeStyles } from "@mui/styles";
import { getSite } from "services/ConfigServices";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import styled from "styled-components";
import ChartV2, { getChartCategoryScriptV2 } from "components/ChartV2/ChartV2";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import CardBody from "components/Card/CardBody";

const useStyles = makeStyles((theme) => ({
  datared: {
    color: "#C53F3F",
    fontWeight: 600
  },
  datanormal: {
    color: "#000000",
    fontWeight: 400
  },
}));
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;
// const Card = styled.div`
//   border: "0";
//   margin-bottom: 0.5rem;
//   margin-top: 0.5rem;
//   padding: 0.9rem;
//   color: black;
//   background: white;
//   width: "100%";
//   box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,
//     rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
//   position: relative;
//   display: flex;
//   flex-direction: column;
//   min-width: 0px;
//   word-wrap: "break-word";
//   font-size: ".875rem";
//   border-radius: 6px;
//   font-family: "Source Sans Pro",sans-serif;
// `;
const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.3rem;
`;
const CardTitle = styled.div`
  font-size: 1rem;
  font-weight: 600;
  opacity: 1;
`;

const Data = styled.div`
  font-size: 0.9rem;
  font-weight: 600;
  opacity: 0.9;
`;
const DataResult = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 0.9rem;
  opacity: 0.9;
`;
const DataContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.1rem 1rem;
  flex-wrap: wrap;
`;
const DataList = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0 0.6rem 0;
`;

export default function Dashboard(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const [tertiarybill, setTertiarybill] = useState("");
  const [chart, setChart] = useState("");
  const [chartgas, setChartgas] = useState("");
  const [chartfioul, setChartfioul] = useState("");
  const [chartcharbon, setChartcharbon] = useState("");
  const [chartwood, setChartwood] = useState("");


  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "tertiarybill"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setTertiarybill(res.data.detail.tertiarybill || {});
        //elec, gaz nat, froid, chaud kWh
        let data = {
          yaxis2: 0,
          series: [],
          xaxisscale: "",
          tooltip: "Evolution de la consommation déclarée sur OPERAT",
          name: "Evolution de la consommation déclarée sur OPERAT",
          xaxistimetick: "day",
          distribution: "site",
          type: "columnchart",
          distributiongroupment: "no",
          yaxis1unit: "kWh",
          version: "v2"
        };
        //gaz liq, gaz prop, gas but kg & m3
        let datagas = {
          yaxis2: 1,
          series: [],
          xaxisscale: "",
          tooltip: "Evolution de la consommation déclarée sur OPERAT",
          name: "Evolution de la consommation déclarée sur OPERAT",
          xaxistimetick: "day",
          distribution: "site",
          type: "columnchart",
          distributiongroupment: "no",
          yaxis1unit: "kg",
          yaxis2unit: "m3",
          version: "v2"
        };
        //fuel litres
        let datafioul = {
          yaxis2: 0,
          series: [],
          xaxisscale: "",
          tooltip: "Evolution de la consommation déclarée sur OPERAT",
          name: "Evolution de la consommation déclarée sur OPERAT",
          xaxistimetick: "day",
          distribution: "site",
          type: "columnchart",
          distributiongroupment: "no",
          yaxis1unit: "litres",
          version: "v2"
        };
        //charbon, houilles kg
        let datacharbon = {
          yaxis2: 0,
          series: [],
          xaxisscale: "",
          tooltip: "Evolution de la consommation déclarée sur OPERAT",
          name: "Evolution de la consommation déclarée sur OPERAT",
          xaxistimetick: "day",
          distribution: "site",
          type: "columnchart",
          distributiongroupment: "no",
          yaxis1unit: "kg",
          version: "v2"
        };
        //bois plaq ind, plaq for, gran ou briq  kg, buches steres
        let datawood = {
          yaxis2: 0,
          series: [],
          xaxisscale: "",
          tooltip: "Evolution de la consommation déclarée sur OPERAT",
          name: "Evolution de la consommation déclarée sur OPERAT",
          xaxistimetick: "day",
          distribution: "site",
          type: "columnchart",
          distributiongroupment: "no",
          yaxis1unit: "kg",
          yaxis2unit: "stères",
          version: "v2"
        };
        let series = [];
        let seriesgas = [];
        let seriesfioul = [];
        let seriescharbon = [];
        let serieswood = [];
        if (res.data.detail.tertiarybill?.declaration?.REFERENCE?.declaredonOperat) {
          //elec, gaz nat, froid, chaud kWh
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiHorsIRVEKWh) {
            let serie = createSerie("Référence", "Electricité", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiHorsIRVEKWh).replace(',', '.')), -1, "a", 1);
            series.push(serie);
          }
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiGazNatReseauxKWh) {
            let serie = createSerie("Référence", "Gaz Naturel", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiGazNatReseauxKWh).replace(',', '.')), -2, "a", 1);
            series.push(serie);
          }
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiReseauChaleurKWh) {
            let serie = createSerie("Référence", "Chaleur", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiReseauChaleurKWh).replace(',', '.')), -3, "a", 1);
            series.push(serie);
          }
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiReseauFroidKWh) {
            let serie = createSerie("Référence", "Froid", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiReseauFroidKWh).replace(',', '.')), -4, "a", 1);
            series.push(serie);
          }
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoComHorsIRVEKWh) {
            let serie = createSerie("Référence", "Electricité", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoComHorsIRVEKWh).replace(',', '.')), -1, "a", 1);
            series.push(serie);
          }
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoComGazNatReseauxKWh) {
            let serie = createSerie("Référence", "Gaz Naturel", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoComGazNatReseauxKWh).replace(',', '.')), -2, "a", 1);
            series.push(serie);
          }
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoComReseauChaleurKWh) {
            let serie = createSerie("Référence", "Chaleur", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoComReseauChaleurKWh).replace(',', '.')), -3, "a", 1);
            series.push(serie);
          }
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoComReseauFroidKWh) {
            let serie = createSerie("Référence", "Froid", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoComReseauFroidKWh).replace(',', '.')), -4, "a", 1);
            series.push(serie);
          }
          //gaz liq, gaz prop, gas but kg & m3
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiGazNatLiquefieKg) {
            let serie = createSerie("Référence", "Gaz Naturel Liquéfié", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiGazNatLiquefieKg).replace(',', '.')), -1, "a", 1);
            seriesgas.push(serie);
          }
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiGazPropaneM3) {
            let serie = createSerie("Référence", "Gaz Propane", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiGazPropaneM3).replace(',', '.')), -2, "b", 1, "right");
            seriesgas.push(serie);
          }
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiGazPropaneKg) {
            let serie = createSerie("Référence", "Gaz Propane", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiGazPropaneKg).replace(',', '.')), -3, "a", 1);
            seriesgas.push(serie);
          }
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiGazButaneM3) {
            let serie = createSerie("Référence", "Gaz Butane", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiGazButaneM3).replace(',', '.')), -4, "b", 1, "right");
            seriesgas.push(serie);
          }
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiGazButaneKg) {
            let serie = createSerie("Référence", "Gaz Butane", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiGazButaneKg).replace(',', '.')), -5, "a", 1);
            seriesgas.push(serie);
          }
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoComGazNatLiquefieKg) {
            let serie = createSerie("Référence", "Gaz Naturel Liquéfié", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoComGazNatLiquefieKg).replace(',', '.')), -1, "a", 1);
            seriesgas.push(serie);
          }
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoComGazPropaneM3) {
            let serie = createSerie("Référence", "Gaz Propane", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoComGazPropaneM3).replace(',', '.')), -2, "b", 1, "right");
            seriesgas.push(serie);
          }
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoComGazPropaneKg) {
            let serie = createSerie("Référence", "Gaz Propane", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoComGazPropaneKg).replace(',', '.')), -3, "a", 1);
            seriesgas.push(serie);
          }
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoComGazButaneM3) {
            let serie = createSerie("Référence", "Gaz Butane", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoComGazButaneM3).replace(',', '.')), -4, "b", 1, "right");
            seriesgas.push(serie);
          }
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoComGazButaneKg) {
            let serie = createSerie("Référence", "Gaz Butane", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoComGazButaneKg).replace(',', '.')), -5, "a", 1);
            seriesgas.push(serie);
          }
          //fuel litres
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiFioulDomestiLitre) {
            let serie = createSerie("Référence", "Fioul domestique", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiFioulDomestiLitre).replace(',', '.')), -1, "a", 1);
            seriesfioul.push(serie);
          }
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoComFioulDomestiLitre) {
            let serie = createSerie("Référence", "Fioul domestique", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoComFioulDomestiLitre).replace(',', '.')), -1, "a", 1);
            seriesfioul.push(serie);
          }
          //charbon, houilles kg
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiCharbonAggloBriqKg) {
            let serie = createSerie("Référence", "Charbon", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiCharbonAggloBriqKg).replace(',', '.')), -1, "a", 1);
            seriescharbon.push(serie);
          }
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiHouilleKg) {
            let serie = createSerie("Référence", "Houille", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiHouilleKg).replace(',', '.')), -2, "a", 1);
            seriescharbon.push(serie);
          }
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoComCharbonAggloBriqKg) {
            let serie = createSerie("Référence", "Charbon", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoComCharbonAggloBriqKg).replace(',', '.')), -1, "a", 1);
            seriescharbon.push(serie);
          }
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoComHouilleKg) {
            let serie = createSerie("Référence", "Houille", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoComHouilleKg).replace(',', '.')), -2, "a", 1);
            seriescharbon.push(serie);
          }
          //bois plaq ind, plaq for, gran ou briq  kg, buches steres
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiBoisPlaqIndustrieKg) {
            let serie = createSerie("Référence", "Bois plaquettes d'industries", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiBoisPlaqIndustrieKg).replace(',', '.')), -1, "a", 1);
            serieswood.push(serie);
          }
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiBoisPlaqForestKg) {
            let serie = createSerie("Référence", "Bois plaquettes forestières", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiBoisPlaqForestKg).replace(',', '.')), -2, "a", 1);
            serieswood.push(serie);
          }
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiBoisGranBriqKg) {
            let serie = createSerie("Référence", "Bois granulés ou briquettes", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiBoisGranBriqKg).replace(',', '.')), -3, "a", 1);
            serieswood.push(serie);
          }
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiBoisBuchesStere) {
            let serie = createSerie("Référence", "Bois bùches", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoIndiBoisBuchesStere).replace(',', '.')), -4, "b", 1, "right");
            serieswood.push(serie);
          }
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoComBoisPlaqIndustrieKg) {
            let serie = createSerie("Référence", "Bois plaquettes d'industries", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoComBoisPlaqIndustrieKg).replace(',', '.')), -1, "a", 1);
            serieswood.push(serie);
          }
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoComBoisPlaqForestKg) {
            let serie = createSerie("Référence", "Bois plaquettes forestières", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoComBoisPlaqForestKg).replace(',', '.')), -2, "a", 1);
            serieswood.push(serie);
          }
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoComBoisGranBriqKg) {
            let serie = createSerie("Référence", "Bois granulés ou briquettes", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoComBoisGranBriqKg).replace(',', '.')), -3, "a", 1);
            serieswood.push(serie);
          }
          if (res.data.detail.tertiarybill.declaration.REFERENCE.consoComBoisBuchesStere) {
            let serie = createSerie("Référence", "Bois bùches", Number((res.data.detail.tertiarybill.declaration.REFERENCE.consoComBoisBuchesStere).replace(',', '.')), -4, "b", 1, "right");
            serieswood.push(serie);
          }
        }
        for (let i = 2021; i < 2050; i++) {
          console.log(res.data.detail.tertiarybill?.declaration["" + i]);
          if (res.data.detail.tertiarybill?.declaration &&
            res.data.detail.tertiarybill?.declaration["" + i]?.declaredonOperat) {
            console.log("step1");
            if (res.data.detail.tertiarybill?.declaration["" + i].consoIndiHorsIRVEKWh) {
              let serie = createSerie("" + i, "Electricité", Number((res.data.detail.tertiarybill.declaration["" + i].consoIndiHorsIRVEKWh).replace(',', '.')), -1, "" + i, i);
              series.push(serie);
            }
            if (res.data.detail.tertiarybill?.declaration["" + i].consoIndiGazNatReseauxKWh) {
              let serie = createSerie("" + i, "Gaz Naturel", Number((res.data.detail.tertiarybill.declaration["" + i].consoIndiGazNatReseauxKWh).replace(',', '.')), -2, "" + i, i);
              series.push(serie);
            }
            if (res.data.detail.tertiarybill?.declaration["" + i].consoIndiReseauChaleurKWh) {
              let serie = createSerie("" + i, "Chaleur", Number((res.data.detail.tertiarybill.declaration["" + i].consoIndiReseauChaleurKWh).replace(',', '.')), -3, "" + i, i);
              series.push(serie);
            }
            if (res.data.detail.tertiarybill?.declaration["" + i].consoIndiReseauFroidKWh) {
              let serie = createSerie("" + i, "Froid", Number((res.data.detail.tertiarybill.declaration["" + i].consoIndiReseauFroidKWh).replace(',', '.')), -4, "" + i, i);
              series.push(serie);
            }
            if (res.data.detail.tertiarybill?.declaration["" + i].consoComHorsIRVEKWh) {
              let serie = createSerie("" + i, "Electricité (répartie)", Number((res.data.detail.tertiarybill.declaration["" + i].consoComHorsIRVEKWh).replace(',', '.')), -1, "" + i, i);
              series.push(serie);
            }
            if (res.data.detail.tertiarybill?.declaration["" + i].consoComGazNatReseauxKWh) {
              let serie = createSerie("" + i, "Gaz Naturel (répartie)", Number((res.data.detail.tertiarybill.declaration["" + i].consoComGazNatReseauxKWh).replace(',', '.')), -2, "" + i, i);
              series.push(serie);
            }
            if (res.data.detail.tertiarybill?.declaration["" + i].consoComReseauChaleurKWh) {
              let serie = createSerie("" + i, "Chaleur (répartie)", Number((res.data.detail.tertiarybill.declaration["" + i].consoComReseauChaleurKWh).replace(',', '.')), -3, "" + i, i);
              series.push(serie);
            }
            if (res.data.detail.tertiarybill?.declaration["" + i].consoComReseauFroidKWh) {
              let serie = createSerie("" + i, "Froid (répartie)", Number((res.data.detail.tertiarybill.declaration["" + i].consoComReseauFroidKWh).replace(',', '.')), -4, "" + i, i);
              series.push(serie);
            }
            //gaz liq, gaz prop, gas but kg & m3
            if (res.data.detail.tertiarybill.declaration["" + i].consoIndiGazNatLiquefieKg) {
              let serie = createSerie("" + i, "Gaz Naturel Liquéfié", Number((res.data.detail.tertiarybill.declaration["" + i].consoIndiGazNatLiquefieKg).replace(',', '.')), -1, "" + i, i);
              seriesgas.push(serie);
            }
            if (res.data.detail.tertiarybill.declaration["" + i].consoIndiGazPropaneM3) {
              let serie = createSerie("" + i, "Gaz Propane", Number((res.data.detail.tertiarybill.declaration["" + i].consoIndiGazPropaneM3).replace(',', '.')), -2, "b" + i, i, "right");
              seriesgas.push(serie);
            }
            if (res.data.detail.tertiarybill.declaration["" + i].consoIndiGazPropaneKg) {
              let serie = createSerie("" + i, "Gaz Propane", Number((res.data.detail.tertiarybill.declaration["" + i].consoIndiGazPropaneKg).replace(',', '.')), -3, "" + i, i);
              seriesgas.push(serie);
            }
            if (res.data.detail.tertiarybill.declaration["" + i].consoIndiGazButaneM3) {
              let serie = createSerie("" + i, "Gaz Butane", Number((res.data.detail.tertiarybill.declaration["" + i].consoIndiGazButaneM3).replace(',', '.')), -4, "b" + i, i, "right");
              seriesgas.push(serie);
            }
            if (res.data.detail.tertiarybill.declaration["" + i].consoIndiGazButaneKg) {
              let serie = createSerie("" + i, "Gaz Butane", Number((res.data.detail.tertiarybill.declaration["" + i].consoIndiGazButaneKg).replace(',', '.')), -5, "" + i, i);
              seriesgas.push(serie);
            }
            if (res.data.detail.tertiarybill.declaration["" + i].consoComGazNatLiquefieKg) {
              let serie = createSerie("" + i, "Gaz Naturel Liquéfié", Number((res.data.detail.tertiarybill.declaration["" + i].consoComGazNatLiquefieKg).replace(',', '.')), -1, "" + i, i);
              seriesgas.push(serie);
            }
            if (res.data.detail.tertiarybill.declaration["" + i].consoComGazPropaneM3) {
              let serie = createSerie("" + i, "Gaz Propane", Number((res.data.detail.tertiarybill.declaration["" + i].consoComGazPropaneM3).replace(',', '.')), -2, "b" + i, i, "right");
              seriesgas.push(serie);
            }
            if (res.data.detail.tertiarybill.declaration["" + i].consoComGazPropaneKg) {
              let serie = createSerie("" + i, "Gaz Propane", Number((res.data.detail.tertiarybill.declaration["" + i].consoComGazPropaneKg).replace(',', '.')), -3, "" + i, i);
              seriesgas.push(serie);
            }
            if (res.data.detail.tertiarybill.declaration["" + i].consoIndiGazButaneM3) {
              let serie = createSerie("" + i, "Gaz Butane", Number((res.data.detail.tertiarybill.declaration["" + i].consoIndiGazButaneM3).replace(',', '.')), -4, "b" + i, i, "right");
              seriesgas.push(serie);
            }
            if (res.data.detail.tertiarybill.declaration["" + i].consoIndiGazButaneKg) {
              let serie = createSerie("" + i, "Gaz Butane", Number((res.data.detail.tertiarybill.declaration["" + i].consoIndiGazButaneKg).replace(',', '.')), -5, "" + i, i);
              seriesgas.push(serie);
            }
            //fuel litres
            if (res.data.detail.tertiarybill.declaration["" + i].consoIndiFioulDomestiLitre) {
              let serie = createSerie("" + i, "Fioul domestique", Number((res.data.detail.tertiarybill.declaration["" + i].consoIndiFioulDomestiLitre).replace(',', '.')), -1, "" + i, i);
              seriesfioul.push(serie);
            }
            if (res.data.detail.tertiarybill.declaration["" + i].consoComFioulDomestiLitre) {
              let serie = createSerie("" + i, "Fioul domestique", Number((res.data.detail.tertiarybill.declaration["" + i].consoComFioulDomestiLitre).replace(',', '.')), -1, "" + i, i);
              seriesfioul.push(serie);
            }
            //charbon, houilles kg
            if (res.data.detail.tertiarybill.declaration["" + i].consoIndiCharbonAggloBriqKg) {
              let serie = createSerie("" + i, "Charbon", Number((res.data.detail.tertiarybill.declaration["" + i].consoIndiCharbonAggloBriqKg).replace(',', '.')), -1, "" + i, i);
              seriescharbon.push(serie);
            }
            if (res.data.detail.tertiarybill.declaration["" + i].consoIndiHouilleKg) {
              let serie = createSerie("" + i, "Houille", Number((res.data.detail.tertiarybill.declaration["" + i].consoIndiHouilleKg).replace(',', '.')), -2, "" + i, i);
              seriescharbon.push(serie);
            }
            if (res.data.detail.tertiarybill.declaration["" + i].consoComCharbonAggloBriqKg) {
              let serie = createSerie("" + i, "Charbon", Number((res.data.detail.tertiarybill.declaration["" + i].consoComCharbonAggloBriqKg).replace(',', '.')), -1, "" + i, i);
              seriescharbon.push(serie);
            }
            if (res.data.detail.tertiarybill.declaration["" + i].consoComHouilleKg) {
              let serie = createSerie("" + i, "Houille", Number((res.data.detail.tertiarybill.declaration["" + i].consoComHouilleKg).replace(',', '.')), -2, "" + i, i);
              seriescharbon.push(serie);
            }
            //bois plaq ind, plaq for, gran ou briq  kg, buches steres
            if (res.data.detail.tertiarybill.declaration["" + i].consoIndiBoisPlaqIndustrieKg) {
              let serie = createSerie("" + i, "Bois plaquettes d'industries", Number((res.data.detail.tertiarybill.declaration["" + i].consoIndiBoisPlaqIndustrieKg).replace(',', '.')), -1, "" + i, i);
              serieswood.push(serie);
            }
            if (res.data.detail.tertiarybill.declaration["" + i].consoIndiBoisPlaqForestKg) {
              let serie = createSerie("" + i, "Bois plaquettes forestières", Number((res.data.detail.tertiarybill.declaration["" + i].consoIndiBoisPlaqForestKg).replace(',', '.')), -2, "" + i, i);
              serieswood.push(serie);
            }
            if (res.data.detail.tertiarybill.declaration["" + i].consoIndiBoisGranBriqKg) {
              let serie = createSerie("" + i, "Bois granulés ou briquettes", Number((res.data.detail.tertiarybill.declaration["" + i].consoIndiBoisGranBriqKg).replace(',', '.')), -3, "" + i, i);
              serieswood.push(serie);
            }
            if (res.data.detail.tertiarybill.declaration["" + i].consoIndiBoisBuchesStere) {
              let serie = createSerie("" + i, "Bois bùches", Number((res.data.detail.tertiarybill.declaration["" + i].consoIndiBoisBuchesStere).replace(',', '.')), -4, "b" + i, i, "right");
              serieswood.push(serie);
            }
             if (res.data.detail.tertiarybill.declaration["" + i].consoComBoisPlaqIndustrieKg) {
              let serie = createSerie("" + i, "Bois plaquettes d'industries", Number((res.data.detail.tertiarybill.declaration["" + i].consoComBoisPlaqIndustrieKg).replace(',', '.')), -1, "" + i, i);
              serieswood.push(serie);
            }
            if (res.data.detail.tertiarybill.declaration["" + i].consoComBoisPlaqForestKg) {
              let serie = createSerie("" + i, "Bois plaquettes forestières", Number((res.data.detail.tertiarybill.declaration["" + i].consoComBoisPlaqForestKg).replace(',', '.')), -2, "" + i, i);
              serieswood.push(serie);
            }
            if (res.data.detail.tertiarybill.declaration["" + i].consoComBoisGranBriqKg) {
              let serie = createSerie("" + i, "Bois granulés ou briquettes", Number((res.data.detail.tertiarybill.declaration["" + i].consoComBoisGranBriqKg).replace(',', '.')), -3, "" + i, i);
              serieswood.push(serie);
            }
            if (res.data.detail.tertiarybill.declaration["" + i].consoComBoisBuchesStere) {
              let serie = createSerie("" + i, "Bois bùches", Number((res.data.detail.tertiarybill.declaration["" + i].consoComBoisBuchesStere).replace(',', '.')), -4, "b" + i, i, "right");
              serieswood.push(serie);
            }
          }
        }
        //  console.log(series);
        data.series = series;
        let charttmp = getChartCategoryScriptV2(data, 999, {}, true);
        setChart(charttmp);

        if (seriesgas.length > 0) {
          datagas.series = seriesgas;
          let charttmp = getChartCategoryScriptV2(datagas, 999, {}, true);
          setChartgas(charttmp);
        }
        if (seriesfioul.length > 0) {
          datafioul.series = seriesfioul;
          let charttmp = getChartCategoryScriptV2(datafioul, 999, {}, true);
          setChartfioul(charttmp);
        }
        if (seriescharbon.length > 0) {
          datacharbon.series = seriescharbon;
          let charttmp = getChartCategoryScriptV2(datacharbon, 999, {}, true);
          setChartcharbon(charttmp);
        }
        if (serieswood.length > 0) {
          datawood.series = serieswood;
          let charttmp = getChartCategoryScriptV2(datawood, 999, {}, true);
          setChartwood(charttmp);
        }
      });
  }, []);

  const createSerie = (year, type, value, groupid, stackid, originalid, yaxis) => {
    let serie = {
      color: "#000000",
      originalname: year,
      groupmentmethod: "SUM",
      groupid: groupid,
      values: [
        {
          "value": value
        }
      ],
      name: "",
      originalid: originalid,
      groupment: "",
      type: "column",
      isdistributed: true,
      groupname: type,
      stackId: stackid,
      yaxis: yaxis || "left"
    };
    return serie;
  }

  const classes = useStyles();

  return (
    <div style={{ marginTop: "-15px" }}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          {tertiarybill?.intertiarybill ?
            <GridContainer>
              <GridItem xs={12} sm={12} md={6}>
                <Card>
                  <CardBody>
                    {/* <TitleContainer>
                    <CardTitle>{"Récapitulatif"}</CardTitle>
                  </TitleContainer> */}
                    <DataList>
                      <DataContainer>
                        <Data>{"Identifiant EFA :"}</Data>
                        <DataResult className={tertiarybill?.idefaoperat ? classes.datanormal : classes.datared}>{tertiarybill?.idefaoperat || 'Non renseigné'}</DataResult>
                      </DataContainer>
                      <DataContainer>
                        <Data>{"Catégorie principale :"}</Data>
                        <DataResult className={tertiarybill?.maincategory ? classes.datanormal : classes.datared}>{tertiarybill?.maincategory || 'Non renseignée'}</DataResult>
                      </DataContainer>
                      <DataContainer>
                        <Data>{"Nombre de catégories :"}</Data>
                        <DataResult className={tertiarybill?.categories?.length ? classes.datanormal : classes.datared}>{tertiarybill?.categories?.length || 'Aucune'}</DataResult>
                      </DataContainer>
                      <DataContainer>
                        <Data>{"Station météo :"}</Data>
                        <DataResult className={tertiarybill?.weatherstation ? classes.datanormal : classes.datared}>{tertiarybill?.weatherstation || 'Non renseignée'}</DataResult>
                      </DataContainer>
                      <DataContainer>
                        <Data>{"Bornes de recharge VE :"}</Data>
                        <DataResult className={tertiarybill?.hasOwnProperty('evcount') ? classes.datanormal : classes.datared}>{tertiarybill?.hasOwnProperty('evcount') ? tertiarybill.evcount : 'Non renseigné'}</DataResult>
                      </DataContainer>
                    </DataList>
                  </CardBody>
                </Card>
              </GridItem>
              <GridItem xs={12} sm={12} md={6}>
                <Card>
                  <CardBody>
                    {/* <TitleContainer>
                    <CardTitle>{"Récapitulatif"}</CardTitle>
                  </TitleContainer> */}
                    <DataList>
                      <DataContainer>
                        <Data>{"Déclaration année de référence :"}</Data>
                        <DataResult className={tertiarybill?.declaration?.REFERENCE?.declaredonOperat ? classes.datanormal : classes.datared}>{tertiarybill?.declaration?.REFERENCE?.declaredonOperat ? "Déclarée" : 'Non déclarée'}</DataResult>
                      </DataContainer>
                      <DataContainer>
                        <Data>{"Déclaration 2021 :"}</Data>
                        <DataResult className={(tertiarybill?.declaration && tertiarybill?.declaration['2021']?.declaredonOperat) ? classes.datanormal : classes.datared}>
                          {(tertiarybill?.declaration && tertiarybill?.declaration['2021']?.declaredonOperat) ? "Déclarée" : 'Non déclarée'}</DataResult>
                      </DataContainer>
                      <DataContainer>
                        <Data>{"Déclaration 2022 :"}</Data>
                        <DataResult className={(tertiarybill?.declaration && tertiarybill?.declaration['2022']?.declaredonOperat) ? classes.datanormal : classes.datared}>
                          {(tertiarybill?.declaration && tertiarybill?.declaration['2022']?.declaredonOperat) ? "Déclarée" : 'Non déclarée'}</DataResult>
                      </DataContainer>
                      <DataContainer>
                        <Data>{"Déclaration 2023 :"}</Data>
                        <DataResult className={(tertiarybill?.declaration && tertiarybill?.declaration['2023']?.declaredonOperat) ? classes.datanormal : classes.datared}>
                          {(tertiarybill?.declaration && tertiarybill?.declaration['2023']?.declaredonOperat) ? "Déclarée" : 'Non déclarée'}</DataResult>
                      </DataContainer>
                      <DataContainer>
                        <Data>{"Déclaration 2024 :"}</Data>
                        <DataResult className={(tertiarybill?.declaration && tertiarybill?.declaration['2024']?.declaredonOperat) ? classes.datanormal : classes.datared}>
                          {(tertiarybill?.declaration && tertiarybill?.declaration['2024']?.declaredonOperat) ? "Déclarée" : 'Non déclarée'}</DataResult>
                      </DataContainer>
                      <DataContainer>
                        <Data>{"Déclaration 2025 :"}</Data>
                        <DataResult className={(tertiarybill?.declaration && tertiarybill?.declaration['2025']?.declaredonOperat) ? classes.datanormal : classes.datared}>
                          {(tertiarybill?.declaration && tertiarybill?.declaration['2025']?.declaredonOperat) ? "Déclarée" : 'Non déclarée'}</DataResult>
                      </DataContainer>
                      <DataContainer>
                        <Data>{""}</Data>
                        <DataResult></DataResult>
                      </DataContainer>
                      <DataContainer>
                        <Data>{""}</Data>
                        <DataResult></DataResult>
                      </DataContainer>
                    </DataList>
                  </CardBody>
                </Card>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                {chart}
              </GridItem>
              {chartgas ?
                <GridItem xs={12} sm={12} md={12}>
                  {chartgas}
                </GridItem> : <></>
              }
              {chartfioul ?
                <GridItem xs={12} sm={12} md={12}>
                  {chartfioul}
                </GridItem> : <></>
              }
              {chartcharbon ?
                <GridItem xs={12} sm={12} md={12}>
                  {chartcharbon}
                </GridItem> : <></>
              }
               {chartwood ?
                <GridItem xs={12} sm={12} md={12}>
                  {chartwood}
                </GridItem> : <></>
              }
            </GridContainer>
            : <NoData>L'entité n'est pas assujettie au décret tertiaire (voir onglet Assujetissement)</NoData>}
        </GridItem>
      </GridContainer>

    </div>
  );
}
